<template>
  <li
    v-style:display="loyaltyDisplayStyle"
    class="rounded-lg p-4 shadow-sm"
    :class="!showSignInPanelLoyaltyDetails || !auth.loggedIn || !user.isLoyaltyMember || !rewardsAvailable.length ? 'bg-white c-brand-1' : 'bg-brand-8 c-white'"
  >
    <base-link v-if="!showSignInPanelLoyaltyDetails || !auth.loggedIn || !user.isLoyaltyMember" class="w-full flex items-center" to="/loyalty" @click="handleLoyaltyClick">
      <vf-icon class="mr-4" size="3xl" :src="logo" />
      <p class="ws-pre-line title-2">
        {{ $t.signInPanel.loyaltyTitle }}
      </p>
      <vf-icon class="ml-a shrink-0" dir="right" name="chevron" size="lg" />
    </base-link>
    <base-link
      v-else-if="rewardsAvailable.length"
      class="flex items-center"
      :to="loyaltyUrl"
    >
      <vf-icon class="mr-4" size="3xl" :src="logo" />
      <div class="f-col">
        <span class="mb-2 subtitle-1">{{ loyaltyMessages.title }}</span>
        <span class="overline-2">{{ loyaltyMessages.text }}</span>
      </div>
    </base-link>
    <base-link v-else class="flex items-center" to="/account/loyalty">
      <vf-icon class="mr-4" size="3xl" :src="logo" />
      <div class="f-col">
        <div class="mb-2 title-2">
          {{ replaceAll($t.signInPanel.loyaltyPoints, { amount: user.loyaltyPointsBalance || 0 }) }}
        </div>
        <div class="f-col">
          <span class="overline-2"> {{ loyaltyEarningRate }}</span>
          <span class="caption-2 c-grey-40">{{ loyaltyEarningWindow }}</span>
        </div>
      </div>
    </base-link>
  </li>
</template>

<script lang="ts" setup>
const auth = useAuthStore()
const cart = useCartStore()
const user = useUserStore()
const route = useRoute()
const currencyCode = useCurrencyCode()
const { logo, showSignInPanelLoyaltyDetails, rewardConversionRate } = useAppConfig().components.vf.loyalty
const { rewardsAvailable } = useLoyaltyStore()
const { getLoyaltyMessages } = useLoyalty()
const { $gtm, $feature, $formatPrice, $t } = useNuxtApp()

const formatReward = (amount: number) => $formatPrice(amount, currencyCode, { minimumFractionDigits: 0 })

const loyaltyEarningRate = computed(() =>
  replaceAll($t.signInPanel.loyaltyEarningRate, { reward: formatReward(rewardConversionRate ?? 0) })
)

const loyaltyEarningWindow = computed(() => replaceAll($t.signInPanel.loyaltyEarningWindow, {
  max: formatReward(50),
  min: formatReward(rewardConversionRate ?? 0)
}))

const loyaltyDisplayStyle = computed(() =>
  Object.entries($feature.disableLoyaltyNavItemOnRoutes || {}).reduce((acc, [key, patternsToDisable]) => {
    acc[key] = patternsToDisable.some((patternToDisable) => convertPatternToRegex(patternToDisable).test(route.path))
      ? 'none'
      : 'flex'
    return acc
  }, {} as Record<string, string>)
)

const loyaltyMessages = computed(() => getLoyaltyMessages())
const loyaltyUrl = computed(() => cart.totalItems > 0 ? '/cart' : '/account/loyalty')

const handleLoyaltyClick = () => $gtm.push('topNav.onClickUtilityLink', 'Join XPLR Pass')
</script>
